'use client';

import { useEffect } from 'react';
import { createStateContext } from 'react-use';

export const [useBreadcrumbContext, BreadcrumbContextProvider] = createStateContext<{
  label: string | null;
}>({
  label: null,
});

export const useBreadcrumbLabel = (label: string | null) => {
  const [, setState] = useBreadcrumbContext();

  useEffect(() => {
    setState({ label });
    return () => {
      setState({ label: null });
    };
  }, [label, setState]);
};
